import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class DynamicDemoService {
	
  async getDynamicDemoById(dynamicDemoId: string) {
	return await Api().get(`${API_URL}/dynamicDemographic/${dynamicDemoId}`, { headers:  authHeader() as any });      
  }
  async find(term: string) {
    return await Api().get(`${API_URL}/dynamicDemographic/find?text=${term}%`, { headers:  authHeader() as any });      
  }

  async updateDynamicDemo(dynamicDemo: any) {
    return await Api().put(`${API_URL}/dynamicDemographic/${dynamicDemo.id}`, dynamicDemo, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createDynamicDemo(dynamicDemo: any) {
    return await Api().post(`${API_URL}/dynamicDemographic/`, dynamicDemo, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteDynamicDemo(dynamicDemo: any) {
    return await Api().delete(`${API_URL}/dynamicDemographic/${dynamicDemo.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }  

  async getMetadata() {
    return await Api().get(`${API_URL}/dynamicDemographic/metadata`, { headers:  authHeader() as any });      
  }
}

export default new DynamicDemoService();